import React, {PureComponent} from "react";
import {SmoothieChart} from "smoothie";
import {TimeSeries} from "smoothie";

class RealTimeGraph extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            series1: null,
            series2: null,
            canvas: null,
            newValue: null,
            graphTitle: "",
        };
    }

    componentDidMount() {
        // Create a time series and find the canvas
        this.setState({
            series1: new TimeSeries(),
            canvas: document.getElementById(this.props.graphRef),
        }, () => {
            console.log("CREATING CHART", this.props.graphRef, "...");

            // Create the chart
            this.chart = new SmoothieChart({
                millisPerPixel: 100,
                grid: {strokeStyle: '#000000'},
                labels: {fillStyle: 'rgb(0,255,17)'},
                tooltip: true,
                responsive: true
            });

            this.chart.addTimeSeries(this.state.series1, {
                lineWidth: 3,
                strokeStyle: '#ff0000',
                fillStyle: 'rgba(255,0,0,0.22)'
            });
            this.chart.streamTo(this.state.canvas, 500);
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (parseInt(prevProps.newValue) !== parseInt(this.props.newValue) || parseInt(prevProps.newValue2) !== parseInt(this.props.newValue2)) {
            this.state.series1.append(Date.now(), this.props.newValue);
            if (this.props.newValue2 && !this.state.series2) {
                this.setState({
                    series2: new TimeSeries(),
                }, () => {
                    this.chart.addTimeSeries(this.state.series2, {
                        lineWidth: 3,
                        strokeStyle: '#13ab00',
                        fillStyle: 'rgba(8,145,0,0.4)'
                    });
                    this.state.series2.append(Date.now(), this.props.newValue2);
                });
            }
            if (this.state.series2) {
                this.state.series2.append(Date.now(), this.props.newValue2);
            }
        }
    }

    render() {
        return (
            <div>
                <h4 className={"App_header"} style={{color: "#000000", textAlign: "right"}}>{this.props.graphTitle}</h4>
                <canvas
                    id={this.props.graphRef}
                    style={{width: "100%", height: 125}}
                />
            </div>
        );
    }
}

export default RealTimeGraph;
